import { Component, Input, Output, EventEmitter } from '@angular/core'
import { NoticeModalProperties } from 'src/lib/entity/gift-point'

@Component({
  selector: 'maglive-notice-modal',
  templateUrl: './notice-modal.component.html',
  styleUrls: ['./notice-modal.component.scss'],
})
export class NoticeModalComponent {
  private isChecked = false

  @Input() noticeModalProperties: NoticeModalProperties
  @Input() isScreenRotated: boolean
  @Output() closeModalEvent = new EventEmitter<void>()
  @Output() acceptBtnEvent = new EventEmitter<void | boolean>()

  cancelBtn() {
    this.closeModalEvent.emit()
  }

  acceptBtn() {
    if (this.noticeModalProperties.isShowCheckbox) {
      this.acceptBtnEvent.emit(this.isChecked)
    } else {
      this.acceptBtnEvent.emit()
    }
    this.closeModalEvent.emit()
  }

  checkboxEvent(event: any) {
    this.isChecked = event.target.checked
  }
}
